/*
 * This file is part of the Convergence API Server.
 *
 * (c) Convergence <https://convergence.finance/>
 */

import gql from "graphql-tag";
import {
    CONVERSATION_FRAGMENT,
    MESSAGE_FRAGMENT
} from "../query/ConversationQuery";

export const CREATE_CONVERSATION = gql`
    mutation CreateConversation($input: CreateConversationInput!) {
        createConversation(input: $input) {
            ...generalConversationFields
        }
    }
    ${CONVERSATION_FRAGMENT}
`;

export const ADD_MESSAGE_MUTATION = gql`
    mutation addMessage($conversation_id: UUID!, $message: String!) {
        addMessage(conversation_id: $conversation_id, message: $message)
    }
`;

export const SEARCH_CONVERSATION_MESSAGE_MUTATION = gql`
    mutation searchMessages($keywords: String!) {
        searchResults: searchMessages(keywords: $keywords) {
            conversation {
                ...generalConversationFields
            }
            conversation_message {
                ...generalMessageFields
            }
        }
    }
    ${MESSAGE_FRAGMENT}
    ${CONVERSATION_FRAGMENT}
`;
